/**
 * Point-to-segment distance and the proper-crossing test, on plan points
 * `{x, z}`. The walkway and continuation code each carried a copy of one or
 * both (`walkwayNetwork`, `walkwayContext`, `trappedFloor`, `seatedSlabCut`,
 * `continuationGates`, `generateLayoutsForTypology`); this is the one they
 * share.
 *
 * Pure. Metres.
 */

/** Distance from `p` to the segment a–b (to `a` when the segment has no length). */
function pointSegmentDistance(p, a, b) {
  const dx = b.x - a.x;
  const dz = b.z - a.z;
  const len2 = dx * dx + dz * dz;
  if (len2 === 0) return Math.hypot(p.x - a.x, p.z - a.z);
  let t = ((p.x - a.x) * dx + (p.z - a.z) * dz) / len2;
  if (t < 0) t = 0;
  else if (t > 1) t = 1;
  return Math.hypot(p.x - (a.x + t * dx), p.z - (a.z + t * dz));
}

/**
 * Do segments a–b and c–d cross each other properly — each strictly through
 * the other's line? Touching at an end, or lying along the same line, is not
 * crossing.
 */
function segmentsProperlyCross(a, b, c, d) {
  const side = (p, q, r) =>
    (q.x - p.x) * (r.z - p.z) - (q.z - p.z) * (r.x - p.x);
  const d1 = side(c, d, a);
  const d2 = side(c, d, b);
  const d3 = side(a, b, c);
  const d4 = side(a, b, d);
  return (
    ((d1 > 0 && d2 < 0) || (d1 < 0 && d2 > 0)) &&
    ((d3 > 0 && d4 < 0) || (d3 < 0 && d4 > 0))
  );
}

module.exports = { pointSegmentDistance, segmentsProperlyCross };
